export default function Badge({ children, ...otherProps }) {
    return <button className="badge" {...otherProps}>{children}</button>
}